import { CurrencyValue, LineChart, formatNumber } from '@blockanalitica/ui';
import {
  SimpleChartData,
  SimpleChartDataset
} from '@blockanalitica/ui/package/types/src/components/charts/SimpleChart';
import { useCallback, useMemo } from 'react';
import { useChartFillDatasetsDates } from '@/hooks';

export default function HistoricGraphs({
  data,
  type,
  underlyingSymbol,
  underlyingAddress,
  network,
  chartDaysAgo
}: {
  data: SimpleChartData[];
  type: string;
  underlyingSymbol: string;
  underlyingAddress: string;
  network: string;
  chartDaysAgo: string;
}) {
  const [datasets] = useMemo(() => {
    const datasets: SimpleChartDataset[] = [
      {
        xField: 'date',
        yField: type
      }
    ];
    const chartType: string = 'line';

    return [datasets, chartType];
  }, [type]);

  const valueFormatter = useCallback(
    (value: string | number) => {
      return (
        <CurrencyValue
          value={value}
          variant="dynamic"
          options={{
            currencySize: '3',
            currency: {
              name: underlyingSymbol,
              address: underlyingAddress,
              network: network
            }
          }}
        />
      );
    },
    [underlyingSymbol, underlyingAddress, network]
  );

  const yScaleValueFormatter = useCallback((value: string | number) => {
    return formatNumber(Number(value));
  }, []);

  const chartData = useChartFillDatasetsDates(data, datasets, chartDaysAgo);

  return (
    <LineChart
      key={type}
      data={chartData}
      datasets={datasets}
      valueFormatter={valueFormatter}
      yScaleValueFormatter={yScaleValueFormatter}
      daysAgo={chartDaysAgo}
    />
  );
}
